  document.addEventListener('click', function (e) {
    const footer = e.target.closest('.cus-footer');
    if (!footer) return;

    footer.classList.toggle('is--footer_opened');

    const content = footer.querySelector('[data-footer-content]');
    if (!content) return;

    const isOpen = footer.classList.contains('is--footer_opened');
    content.style.display = isOpen ? 'block' : 'none';
  });
